module.exports = __webpack_public_path__ + "img/Stickers-samengevat.ccc2b87.png";